export default {
	home: {
		name: "add goods"
	},
	page_out_trade_no: "Número de Pedido del Comerciante"
};
